import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../assets/logo2.png";

// Styled component for the loader container
const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff; /* White background, adjust as needed */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.5s ease-out;
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
`;

// Styled component for the pulsing logo
const PulsingLogo = styled.img`
  width: 300px; /* Adjust size as needed */
  height: 150px;
  animation: pulse 1.5s infinite ease-in-out;

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const LogoLoader = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Set a timer to hide the loader after 2.5 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2500); // 2.5 seconds

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, []);

  return (
    <LoaderContainer isVisible={isVisible}>
      <PulsingLogo src={logo} alt="Logo" />
    </LoaderContainer>
  );
};

export default LogoLoader;